import Scene from './Scene';
import Game from '../Game';
import RenderSystem from '../System/Render/RenderSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';
import FarmTransitionSystem from 'System/FarmTransitionSystem';

export default class FarmTransitionScene extends Scene {
    public init(): void {
        this.addSystem(new FarmTransitionSystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));

        this.systems.forEach(system => system.init());
    }

    public async preload() {
        addDragonbonesResources('my_farm_loading', `${DRAGONBONES_PATH}/MyFarmLoading/`);

        Game.resource.add(
            'my_farm_bg',
            'resource/graphics/other/my_farm_bg.jpg'
        );

        return Game.resource.load();
    }
}
